import { render, staticRenderFns } from "./KorrespondenzInhalt.vue?vue&type=template&id=4ee9e764"
import script from "./KorrespondenzInhalt.vue?vue&type=script&lang=js"
export * from "./KorrespondenzInhalt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports